import { useQuery } from '@tanstack/react-query';
import { request } from 'javascripts/services/v3ApiClient';
import type {
  V3ApiMetaData,
  V3ApiSuccessData,
  V3ApiErrorData,
} from 'javascripts/services/v3ApiClient';

type LanguageObject = {
  data: {
    comments: {
      [key: string]: string;
    };
    model: string;
  };
  meta: V3ApiMetaData;
  errors: [];
};

export type GetLanguagesResponse = V3ApiSuccessData<LanguageObject[]>;

type GetLanguagesParams =
  | {
      photoId: string;
    }
  | {
      projectId: string;
    };

export const useGetLanguages = ({
  nodeId,
  params,
}: {
  nodeId: string;
  params: GetLanguagesParams;
}) => {
  const { isLoading, isError, data, isFetched, refetch } = useQuery<
    GetLanguagesResponse,
    V3ApiErrorData
  >({
    queryFn: async () => {
      const response = await request({
        url: `language_detections`,
        method: 'POST',
        data: params,
      });
      return response.data;
    },
    queryKey: ['language_detections', { nodeId }],
  });

  return {
    data,
    isLoading,
    isError,
    isFetched,
    refetch,
  };
};
